import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
// import HOCs
import { withDelete } from "./withDelete";
import { styles as pageStyles, withPage } from "./withPage";
import { withView } from "./withView";

// export HOCs
export { withDelete, withView, withPage, pageStyles };

// expose classes for direct use
class pageView extends React.Component {
  render = () => "";
}

class pageDelete extends React.Component {
  render = () => "";
}

export const PageDelete = compose(withRouter, withDelete)(pageDelete);
export const PageView = compose(withRouter, withView)(pageView);
export const Page = compose(withRouter, withPage, withStyles(pageStyles))(
  pageView
);



// WEBPACK FOOTER //
// ./src/library/pages/index.js